import Vue from 'vue';

export default Vue.directive('background-image', {
  bind (el, binding) {
    el.style.backgroundImage = `url(${binding.value})`;
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center';
  },
  update (el, binding) {
    el.style.backgroundImage = `url(${binding.value})`;
  }
});
